module.exports = __webpack_public_path__ + "static/assets/GlacialIndifference-Regular.db38a155.woff";